<template>
	<div class="guest-form-container form-container">
		<div class="center-message">
			<p>Continue order as a guest?</p>
			<p>Please enter your details:</p>
		</div>
		<div class="contact-form">
			<div class="contact-field" :class="validateClass(hasValidName(guestNameModel))">
				<BaseIcon
					class="input-field-icon"
					icon="userEdit"
					size="1x"/>
				<input class="input text-input has-icon" type="text" placeholder="Name" v-model="guestNameModel" @blur="updateName()" />
			</div>
			<div class="contact-field" :class="updatePhoneClass()">
				<BaseIcon
					class="input-field-icon"
					icon="phone"
					size="1x"/>
				<input class="input text-input has-icon" type="tel" placeholder="Phone (607) 123 4567" v-model="phone" @blur="updatePhone()" />
			</div>
			<div class="terms-wrapper">
				<label class="control control--checkbox cust-radio" ref="leaveAtDoorCheckbox">
					<input
						type="checkbox"
						role="checkbox"
						aria-label="accept terms of service"
						v-model="acceptTerms"
					/>
					<div class="control__indicator checkbox"></div>
					<p class="is-size-7">
						I agree to the <a class="red-link" target="_blank" href="https://www.touchpoint.io/terms">Terms of Service</a>. Learn about how we use and protect your data in our <a class="red-link" target="_blank" href="https://www.touchpoint.io/privacy">Privacy Policy</a>
					</p>
				</label>
			</div>
			<div class="contact-form">
				<BaseButton
					:classNames="['button--modifier', 'input-field-button']"
					title="Continue"
					type="scaleable-fixed-square"
					:disabled="!validateAccount() || !acceptTerms"
					@click="handleClickContinue"/>
			</div>
			<a class="small-link" @click.prevent="_navigateToSignIn">or sign in with an account</a>
		</div>
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import layoutMixin from '@Mixin/layoutMixin';
	import contactDetailsMixin from '@Mixin/contactDetailsMixin';
	import locationsMixin from '@Mixin/locationsMixin';
	import loginMixin from '@Mixin/loginMixin';
	import headerMixin from '@Mixin/headerMixin';
	import addressMixin from '@Mixin/addressMixin';
	// TODO consider extending contact details or factoring out inputs
	export default {
		mixins: [
			layoutMixin,
			contactDetailsMixin,
			locationsMixin,
			loginMixin,
			headerMixin,
			addressMixin,
		],
		components: {},
		props: {},
		data() {
			return {
				guestNameModel: '',
				guestEmailModel: '',
				acceptTerms: false
			};
		},
		computed: {},
		methods: {
			navigateToCheckout() {
				this.$router.push({
					path: '/checkout',
					query: {},
				});
			},
			handleClickContinue() {
				this.setIsGuest(true);
				this._addInitialAddress();
				if (this._hasCompletedRoute) {
					this._navigateToCompletedRoute();
					return;
				}
				this.navigateToCheckout();
			},
			showGuestSaveError() {
				EventBus.$emit(
					'display-network-failure',
					`We are having service issues at the moment. If these issues persist please call: \n${this.storePhone}\n to place an order`
				);
			},
		},
		mounted() {
			this.setRouteLayout({
				name: 'Checkout',
				value: 'MinimalCheckout',
			});
			this.guestNameModel = this.userName;
			this._setHeaderTitle('Guest Sign In');
		},
		created() {
			EventBus.$on('guest-error', this.showGuestSaveError);
		},
		destroyed() {
			EventBus.$off('guest-error');
		},
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/checkout';
	@import 'commonStyle/contactForm';
	.small-link {
		width: 100%;
		text-align: right;
	}
	.terms-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		label.control {
			max-width: 320px;
			margin-bottom: 0;
			padding-bottom: 0;
			.checkbox {
				top: 10px;
			}
			.red-link {
				color: red;
				text-decoration: underline;
				cursor: pointer;
			}
			p {
				text-align: left;
				margin-left: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/account/GuestForm.vue